import { eventNoteForCreate, IEventNote, IPendingEventNote } from '../../data/entities/event/event-note';
import { ActionTypeNames, ActionValues, createActionCreators } from '../../store/actions';
import { ThunkAction } from '../../store/middleware';

const eventNoteQueueActions = createActionCreators<
	{ T: 'EVENT_NOTE_CREATE_QUEUE', P: IPendingEventNote },
	{ T: 'EVENT_NOTE_CREATE_QUEUE_CLEAR' }
	>(
		'EVENT_NOTE_CREATE_QUEUE',
		'EVENT_NOTE_CREATE_QUEUE_CLEAR'
	);

const eventNoteCreateActions = createActionCreators<
	{ T: 'EVENT_NOTE_CREATE_REQUEST' },
	{ T: 'EVENT_NOTE_CREATE_RECEIVE', P: { eventNotes: IEventNote[] } },
	{ T: 'EVENT_NOTE_CREATE_FAILURE', P: { error: Error } }
	>(
		'EVENT_NOTE_CREATE_REQUEST',
		'EVENT_NOTE_CREATE_RECEIVE',
		'EVENT_NOTE_CREATE_FAILURE'
	);

const eventNoteDeleteActions = createActionCreators<
	{ T: 'EVENT_NOTE_DELETE', P: IEventNote },
	{ T: 'EVENT_NOTE_DELETE_RECEIVE', P: { id: number } },
	{ T: 'EVENT_NOTE_DELETE_FAILURE', P: { id: number, error: Error }}
	>(
		'EVENT_NOTE_DELETE',
		'EVENT_NOTE_DELETE_RECEIVE',
		'EVENT_NOTE_DELETE_FAILURE'
	);

export const createEventNotes = (propertyId: string, eventId: string, eventNotes: eventNoteForCreate[]): ThunkAction<any> =>
	async (dispatch, getState, { _deprecatedApi: api }) => {
		dispatch(eventNoteCreateActions.EVENT_NOTE_CREATE_REQUEST());
		try {
			const response = await api.eventNotes.createEventNotes(propertyId, eventId, eventNotes);

			dispatch(eventNoteCreateActions.EVENT_NOTE_CREATE_RECEIVE({ eventNotes: response }));
			dispatch(eventNoteQueueActions.EVENT_NOTE_CREATE_QUEUE_CLEAR());
		} catch (error) {
			dispatch(eventNoteCreateActions.EVENT_NOTE_CREATE_FAILURE({ error }));
		}
	};

export const queueEventNote = (action: 'add' | 'remove', eventNote: eventNoteForCreate, eventId: string): ThunkAction<any> =>
	async (dispatch, getState, { _deprecatedApi: api }) => {
		dispatch(eventNoteQueueActions.EVENT_NOTE_CREATE_QUEUE({ action, eventNote, eventId }));
	};

export const clearEventNoteQueue = (): ThunkAction<any> =>
	async (dispatch, getState, { _deprecatedApi: api }) => {
		dispatch(eventNoteQueueActions.EVENT_NOTE_CREATE_QUEUE_CLEAR());
	};

export const deleteEventNote = (propertyId: string, eventId: string, eventNote: IEventNote): ThunkAction<any> =>
	async (dispatch, getState, { _deprecatedApi: api }) => {
		dispatch(eventNoteDeleteActions.EVENT_NOTE_DELETE());
		try {
			await api.eventNotes.deleteEventNote(propertyId, eventId, eventNote.id!);

			dispatch(eventNoteDeleteActions.EVENT_NOTE_DELETE_RECEIVE({ id: eventNote.id! }));
		} catch (error) {
			dispatch(eventNoteDeleteActions.EVENT_NOTE_DELETE_FAILURE({ id: eventNote.id!, error }));
		}
	};

const actions = {...eventNoteQueueActions, ...eventNoteCreateActions, ...eventNoteDeleteActions };

type EventNoteActions = ActionValues<typeof actions>;
type EventNoteActionTypes = ActionTypeNames<EventNoteActions>;
export type Actions = EventNoteActions[keyof EventNoteActions];
export const ActionTypes = Object.keys(actions).reduce((types, t) => {
	types[t] = t;
	return types;
}, {} as EventNoteActionTypes);
